import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(public authService: AuthService) {}

  public getTokenHeader() {
    let accessToken = this.authService.userData.data.tokens.access_token;
    let _header: HttpHeaders = new HttpHeaders({
      Authorization: accessToken,
    });
    return _header;
  }
}
